import { icon } from "@fortawesome/fontawesome-svg-core/import.macro"

import useHasAccess from "@hooks/useHasAccess"
import useIsDesktop from "@hooks/useIsDesktop"

import { Badge, Icon, IconButton, Tooltip } from "@atoms"

import useJobTimelineViewData from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewData"
import useJobTimelineViewStates from "@pages/Jobs/JobList/views/JobTimelineView/hooks/useJobTimelineViewStates"

import { PERMISSION_LEVEL } from "@constants/permissionLevel"

import styles from "./UnscheduledJobsHeader.module.scss"

export default function UnscheduledJobsHeader() {
    const isDesktop = useIsDesktop()
    const { unscheduledJobsColumnStatus, unscheduledJobsColumnMessageStatus, collapseUnscheduledJobsColumn } =
        useJobTimelineViewStates()

    const { unscheduledJobsCount } = useJobTimelineViewData()

    const { hasPermission } = useHasAccess()

    if (
        unscheduledJobsColumnStatus === "collapsed" ||
        !isDesktop ||
        !hasPermission("jobs_edit_permission", PERMISSION_LEVEL.FULL)
    ) {
        return null
    } else {
        return (
            <div className={styles.base}>
                <div className={styles.questionMarkAndTitle}>
                    {unscheduledJobsColumnMessageStatus !== "initial" && (
                        <Tooltip
                            type="message"
                            icon={
                                <Icon
                                    className={styles.questionMarkIcon}
                                    icon={icon({
                                        name: "circle-dashed",
                                        style: "solid",
                                        family: "sharp",
                                    })}
                                />
                            }
                            title="Unscheduled Jobs"
                            message="We currently only support scheduling Unscheduled jobs from the side panel. To manage Draft, Past Due, and On Hold jobs, switch to Table view."
                        >
                            <div className={styles.questionMark}>
                                <Icon
                                    icon={icon({
                                        name: "question-circle",
                                        style: "light",
                                        family: "sharp",
                                    })}
                                    iconOnMouseOver={icon({
                                        name: "question-circle",
                                        style: "solid",
                                        family: "sharp",
                                    })}
                                />
                            </div>
                        </Tooltip>
                    )}
                    <div className={styles.title}>Unscheduled Jobs</div>
                    <Badge
                        colorScheme={unscheduledJobsCount === 0 ? "gray" : "tomato"}
                        size="md"
                        variant="subtle"
                        type="counter"
                    >
                        {unscheduledJobsCount.toString()}
                    </Badge>
                </div>

                <div className={styles.button}>
                    <IconButton
                        colorScheme="gray"
                        size="sm"
                        variant="ghost"
                        icon={icon({
                            name: "arrow-right-to-line",
                            style: "light",
                            family: "sharp",
                        })}
                        onClick={collapseUnscheduledJobsColumn}
                        aria-label="Collapse Unscheduled Jobs"
                        noDebounce={true}
                    />
                </div>
            </div>
        )
    }
}
